var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonthlyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 20,
    rx: 5,
    fill: "#1D5AB9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7485 16.3108C14.365 16.3108 17.2968 13.4057 17.2968 9.82206C17.2968 6.23846 14.365 3.33337 10.7485 3.33337C7.13197 3.33337 4.2002 6.23846 4.2002 9.82206C4.2002 13.4057 7.13197 16.3108 10.7485 16.3108Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.748 5.92883V9.82205L13.3674 11.1198",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonthlyIcon);
export default __webpack_public_path__ + "static/media/monthlyIcon.9ef1e80b5f0ca20c420ddc48381d71fd.svg";
export { ForwardRef as ReactComponent };